<div class="oiq-ui-dialog onyxiq-theme-v2 w-full max-w-[500px]">
  <header>
    <div class="flex items-center justify-between">
      <h2 class="!text-left !text-base !leading-none !text-gray-1">Add New Mail</h2>
      <button class="oiq-button oiq-button--link __close" type="button" (click)="onClose()">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>
  </header>

  <main class="mx-2 flex flex-col gap-2 bg-white !px-6 !py-6">
    <oiq-email-provider-select
      welcomeTitle="Add New Mail"
      description="Select your email provider and start using the Email Application in just a few minutes"
      (providerSelected)="onProviderSelected($event)">
    </oiq-email-provider-select>
  </main>

  <footer>
    <div class="flex w-full justify-end">
      <button type="button" class="oiq-button oiq-button--outline" (click)="onClose()">
        Close
      </button>
    </div>
  </footer>
</div>
